import { useWizard } from 'react-use-wizard';
import { TrendingUp, Circle } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@design-system';

import { StepLayout } from '@/features/guided-financial-planning/components/step-layout';

const ASSESSMENT_BULLETS = [
  'Get details on each of your accounts',
  'Project your future self-funding capacity',
  'Identify any coverage gaps',
];

export function AssessmentIntroStep() {
  const { nextStep, previousStep, isFirstStep } = useWizard();

  return (
    <StepLayout
      title="Step 1: Coverage Assessment"
      subtitle="First, we're going to figure out how much you have to cover long-term care today, whether it's through insurance you already own, self-funding, or other sources."
      icon={
        <div className="bg-primary/10 flex size-14 items-center justify-center rounded-full">
          <TrendingUp className="text-primary size-7" />
        </div>
      }
      nextButtonLabel="Let's Start Step 1"
      onNext={nextStep}
      onBack={previousStep}
      hideBack={isFirstStep}
    >
      <div className="flex flex-col items-center">
        <Card className="w-full max-w-3xl gap-3 bg-gray-50">
          <CardHeader>
            <CardTitle>What we'll do:</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-3">
              {ASSESSMENT_BULLETS.map(bullet => (
                <li
                  key={bullet}
                  className="flex items-start gap-3"
                >
                  <Circle className="text-primary mt-1.5 size-3 shrink-0" />
                  <span className="text-gray-700">{bullet}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    </StepLayout>
  );
}
